const toggles = document.querySelectorAll('.toggle-password');

toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
        const parent = this.parentElement;
        if (parent) {
            const passwordInput = parent.querySelector('.password-input');
            const showIcon = parent.querySelector('.icon-show');
            const hideIcon = parent.querySelector('.icon-hide');

            if (passwordInput && showIcon && hideIcon) {
                const isHidden = passwordInput.type === 'password';
                passwordInput.type = isHidden ? 'text' : 'password';
                showIcon.style.display = isHidden ? 'none' : 'inline-block';
                hideIcon.style.display = isHidden ? 'inline-block' : 'none';
            }
        }
    });
});